import React from 'react';

const bandPhoto = '/harlan-band-main.PNG';
const memberPlaceholder = '/member-placeholder.svg';

type Member = {
  name: string;
  role: string;
  photo: string;
  photoClass?: string;
  bio: string;
};

const members: Member[] = [
  {
    name: 'Jon Harlan',
    role: 'Lead Vocals',
    photo: '/jon.jpg',
    bio: 'The voice out front. Jon built Harlan on 90s country attitude and a live show that still hits like a Saturday night radio request.',
  },
  {
    name: 'Joe McNasty Meyer',
    role: 'Lead Guitar',
    photo: memberPlaceholder,
    bio: 'Telecaster sting and chicken-pickin’ flash. Holds the solos, the hooks, and the high-lonesome bite that makes a honky-tonk room lean in.',
  },
  {
    name: 'Bo Wonder-red Duncan',
    role: 'Bass',
    photo: '/bo.jpg',
    photoClass: 'member-photo--bo',
    bio: 'The low end that keeps the floor moving. Tight pocket, road-tested groove, and the kind of time that makes a dancehall feel easy.',
  },
  {
    name: 'Bradley Reed',
    role: 'Drums',
    photo: '/bradley.png',
    bio: 'Backbeat with a boot-stomp. Drives the two-step, the breakdowns, and the encore without ever getting in the way of the song.',
  },
  {
    name: 'Melissa Fiddletown Southwick',
    role: 'Fiddle',
    photo: '/melissa.PNG',
    bio: 'Bow on fire and harmony on top. Melissa puts the high-lonesome sting in the breaks and the lift in every chorus.',
  },
];

export function AboutPage() {
  return (
    <section className="panel inner-page about-page">
      <figure className="about-hero">
        <img src={bandPhoto} alt="Harlan" />
      </figure>
      <div className="panel-header">
        <p className="eyebrow">The band</p>
        <h2>About</h2>
        <p className="lede">
          Northern California country with stadium polish. Five players, one sound: the hits people grew up on, and the
          ones they still want at last call.
        </p>
      </div>
      <div className="member-grid">
        {members.map((member) => (
          <article key={member.role} className="card member-card">
            <img className={`member-photo ${member.photoClass ?? ''}`} src={member.photo} alt={member.name} />
            <div className="member-meta">
              <p className="eyebrow">{member.role}</p>
              <h3>{member.name}</h3>
              <p>{member.bio}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
